import { GridLegacy } from "@mui/material";

import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import { FormAsyncPreDiningArrangement } from "../../../components/Forms/Arrangements/FormAsyncPreDiningArrangement";

function Arrangements() {
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <GridLegacy container spacing={1}>
        <GridLegacy alignContent={"flex-start"} item xs={12}>
          <Card>
            <CardBody style={{ display: "flex", flexWrap: "wrap" }}>
              <GridLegacy item xs={12}>
                <h3>
                  <TranslationWrapper tKey={"Arrangements"} />
                </h3>
              </GridLegacy>
              <FormAsyncPreDiningArrangement />
            </CardBody>
          </Card>
        </GridLegacy>
      </GridLegacy>
    </div>
  );
}

export default Arrangements;
